import React from 'react';
import { Filter } from 'lucide-react';
import { CategoryDropdown } from '../ui';

const FilterSidebar = ({
  selectedFilters,
  setSelectedFilters,
  clearFilters
}) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-md">
      <div className="flex justify-between items-center mb-3">
        <h3 className="font-semibold flex items-center gap-2">
          <Filter className="h-4 w-4" />
          Filters
        </h3>
        <button
          onClick={clearFilters}
          className="text-sm text-blue-600 hover:text-blue-700 hover:underline"
        >
          Clear All
        </button>
      </div>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">Category</label>
          <CategoryDropdown
            value={selectedFilters.category}
            onChange={(category) => setSelectedFilters({...selectedFilters, category})}
            showAllOption={true}
            allOptionLabel="All Categories"
      />
      </div>
        <div>
          <label className="block text-sm font-medium mb-1">Availability</label>
          <select
            value={selectedFilters.availability}
            onChange={(e) => setSelectedFilters({...selectedFilters, availability: e.target.value})}
            className="w-full border border-gray-300 rounded px-3 py-2"
          >
            <option value="all">All Items</option>
            <option value="available">Available Now</option>
            <option value="checked_out">Currently Checked Out</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Max Distance (miles)</label>
          <input
            type="range"
            min="1"
            max="2800"
            value={selectedFilters.maxDistance}
            onChange={(e) => setSelectedFilters({...selectedFilters, maxDistance: parseInt(e.target.value)})}
            className="w-full"
          />
          <div className="text-sm text-gray-600 text-center">{selectedFilters.maxDistance} miles</div>
        </div>
      </div>
    </div>
  );
};

export default FilterSidebar;